import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const isAccountChargeSelected = createSelector(creditCardsState, (creditCards) => creditCards.activeCardId === OLO.Enums.PAYMENT_VENDOR_SERVICE.ACCOUNT_CHARGE);
